// Imports
import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../shared/i18n";
import vuetify from "../shared/plugins/vuetify";
import * as Sentry from "@sentry/vue";
import { HttpClient } from "@sentry/integrations";

// global window properties
declare global {
  interface Window {
    OpticalGymMode: string;
    OpticalGymApp: string;
    OpticalGymVersion: string;
    OcudigitalLogError(error: Object, additional: { [key: string]: any }): void;
    VueApp: Vue;
    messageBus: Vue;
  }
}

// Registers window.OcudigitalLogError
import "../shared/plugins/log_error";

// XSS plugin
import xssPlugin from "../shared/plugins/xss-plugin";

// Inactivity-based auto-reload after long hidden periods
import "../shared/plugins/inactivity-reload";

// TODO: typescriptafy this
// @ts-ignore
import routes from "./routes.js";

// TODO: typescriptafy this
// @ts-ignore
import App from "./App.vue";

// Global vue config
Vue.use(VueRouter);
Vue.use(xssPlugin);

if (window.OpticalGymMode != "development") {
  Vue.config.productionTip = false;
}

// Vuex Store
import store from "../shared/VuexStore";

// Router
var router = new VueRouter({
  routes: routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition): { x: number, y: number } {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// Global message bus
window.messageBus = new Vue({
  i18n,
});

vuetify.framework.theme.dark = true;
vuetify.framework.theme.themes.dark.primary = "#EC2027";
vuetify.framework.theme.themes.dark.secondary = "#333537";

let sentry_config: any = {
  Vue,
  environment: window.OpticalGymMode,
  dsn: "https://78c4386a38e9d4202ea33948dcf88c2d@o4506152454062080.ingest.sentry.io/4506152456486912",
  integrations: [new HttpClient()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "neurovisualtrainer.com", "app.visionxsports.com", "visionx-stage.ocudigital.com", "stage.ocudigital.com"],

  // Capture Replay for 1% of all sessions,
  // plus for 10% of sessions with an error
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.1,
};

if (window.OpticalGymVersion) {
  sentry_config.release = window.OpticalGymVersion;
}

// Init sentry if we are not in print mode
let query_params = new URLSearchParams(window.location.search);
let print_mode = query_params.get("print") == "true";

if (!print_mode) {
  Sentry.init(sentry_config);
}

// Initialize
window.VueApp = new Vue({
  i18n,
  vuetify,
  store,
  render: (h) => h(App),
  router: router,
}).$mount("#app");
